/**
 * Whether the page on screen was painted from prerendered HTML.
 *
 * scripts/prerender.mjs saves each route with its content already inside
 * #root, so the hero is visible before the bundle arrives. React then renders
 * over it from scratch (createRoot, not hydrateRoot), and an entrance that
 * starts at opacity 0 would blank the hero the reader is already looking at
 * and fade it back in. The hero reads this once to skip its entrance.
 *
 * True only until the first commit: index.js calls settlePrerender() after
 * mounting, so a later client-side visit to "/" still gets the entrance.
 */
let painted =
  typeof document !== "undefined" &&
  document.getElementById("root")?.hasChildNodes() === true;

export const paintedFromPrerender = () => painted;

export const settlePrerender = () => {
  painted = false;
};
